<template>
  <div class="toggle-switch"></div>
</template>

<script>
export default {
    name: 'ToggleSwitch',
};
</script>

<style>
.toggle-switch {
    margin: 0;
    padding: 0;
    width: 48px;
    height: 28px;
    border: none;
    outline: none;
    overflow: hidden;
    position: relative;
    border-radius: 14px;
    display: inline-block;
    background: #404346;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}

.toggle-switch,
.toggle-switch:before,
.toggle-switch:after {
    transition: all 200ms ease-in-out;
}

.toggle-switch:before {
    top: 4px;
    left: 24px;
    content: "";
    width: 20px;
    height: 20px;
    display: block;
    position: absolute;
    border-radius: 12px;
    background: #DCE0E3;
}

.toggle-switch:after {
    content: "";
    top: 14px;
    right: 2px;
    width: 1px;
    height: 1px;
    display: block;
    position: absolute;
    border-radius: 0.5px;
    background: #404346;
}

.toggle-switch:hover,
.toggle-switch:hover:after {
    background: #2D2F31;
}

.toggle-switch:focus,
.toggle-switch:active,
.toggle-switch:active:after {
    background: #141516;
}

.v-theme--dark .toggle-switch {
    width: 48px;
}

.v-theme--dark .toggle-switch {
    background: #DCE0E3;
}

.v-theme--dark .toggle-switch:before {
    left: 4px;
    background: #2D2F31;
}

.v-theme--dark .toggle-switch:after {
    top: -2px;
    right: 2px;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    background: #DCE0E3;
}

.v-theme--dark .toggle-switch:hover,
.v-theme--dark .toggle-switch:hover:after {
    background: #FCFEFE;
}

.v-theme--dark .toggle-switch:focus,
.v-theme--dark .toggle-switch:active,
.v-theme--dark .toggle-switch:active:after {
    background: #CDD1D5;
}
</style>
